import { __rest } from "tslib";
import { reportClientEvent as reportEvent } from '@lusha/bi-client-sdk';
import config from '../../config';
const reportClientEvent = (_a) => {
    var { platform = 'plugin', subPlatform = 'linkedin', pageUrl } = _a, metadata = __rest(_a, ["platform", "subPlatform", "pageUrl"]);
    reportEvent({
        teamName: 'plugin',
        isLoggedIn: true,
        metadata: Object.assign(Object.assign({ platform,
            subPlatform,
            pageUrl }, metadata), { eventAdditionalInfo: Object.assign({ plugin_version: config.version }, (metadata.eventAdditionalInfo || {})) }),
    });
};
export default reportClientEvent;
